"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DynoSidePreview = _interopRequireDefault(require("./DynoSidePreview"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _default = _react.default.createClass({
  displayName: "DynoPanels",
  propTypes: {
    children: _react.default.PropTypes.element.isRequired,
    step: _react.default.PropTypes.string.isRequired,
    dyno: _react.default.PropTypes.object.isRequired,
    hasForm: _react.default.PropTypes.bool
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        step = _this$props.step,
        dyno = _this$props.dyno,
        hasForm = _this$props.hasForm;
    var demoState = _DynoEditor.STEPS_TO_STATE[step];
    return _react.default.createElement(_UIGrid.default, {
      className: "dyno-editor"
    }, _react.default.createElement(_UIGridItem.default, {
      size: 4,
      className: "dyno-editor__editor-panel"
    }, children), _react.default.createElement(_UIGridItem.default, {
      size: 8,
      className: "dyno-editor__preview-panel"
    }, _react.default.createElement(_DynoSidePreview.default, {
      hasForm: hasForm,
      dyno: dyno,
      interactionDisabled: step !== _DynoEditor.STEPS.TYPE,
      state: demoState,
      step: step
    })));
  }
});

exports.default = _default;
module.exports = exports.default;